import { useEffect } from 'react';

import { useAuthMe } from '@/features/auth/hooks';
import { useAuthStore } from '@/store/authStore';

export function useAuthInit() {
  const accessToken = useAuthStore(state => state.accessToken);
  const setUser = useAuthStore(state => state.setUser);
  const logout = useAuthStore(state => state.logout);

  const shouldFetchUser = !!accessToken;

  const { data: fetchedUser, isError } = useAuthMe({
    enabled: shouldFetchUser,
  });

  useEffect(() => {
    if (fetchedUser) {
      setUser(fetchedUser);
    }
  }, [fetchedUser, setUser]);

  useEffect(() => {
    if (isError && accessToken) {
      logout();
    }
  }, [isError, accessToken, logout]);
}
